<template>
    <div class="linked_block">
        
        <b-table   thead-class="bg-primary text-white" class="table-responsive-lg"  striped  :items="files" :fields="fields">
            
            <template  v-slot:head(infoblock)="data" >
                <span class="text-center" v-html="data.label"></span>
            </template>
            
            <template  v-slot:cell(infoblock)="data" >
                <i class="fas fa-indent show_inside-" @click="data.toggleDetails"></i>
            </template>
            
            <template v-slot:cell(quest_name)="data" >
                <a :href="data.item.link" target="_blank" >{{data.value}}</a>
            </template>
            
            <template v-slot:row-details="row" >
                <b-card>
                    <b-row class="mb-2">
                        <b-col sm="2" class="text-sm-left">
                            Преамбула
                        </b-col>
                        <b-col v-html="row.item.obj.pre_text"></b-col>
                    </b-row>
                    
                    <b-row class="mb-2">
                        <b-col sm="2" class="text-sm-left">
                            Проблема
                        </b-col>
                        <b-col v-html="row.item.obj.problem"></b-col>
                    </b-row>
                    
                    
                    <b-row class="mb-2">
                        <b-col sm="2" class="text-sm-left">
                            Запропоноване рішення
                        </b-col>
                        <b-col  v-html="row.item.obj.result" ></b-col>
                    </b-row>
                </b-card>
            </template>
        </b-table>
    </div>
</template>

<script>
export default {
    name: "tab_linked",
    
    props: {
        doc_id: {
            type: Number,
            required: true
        },
    },
    
    data() {
        return {
            
            fields: [
                {
                    key : 'infoblock',
                    label: ' <i class="fa fa-indent show_inside" aria-hidden="true"></i>',
                    sortable: false
                },
                {
                    key: 'number',
                    label: 'Номер',
                    sortable: true
                },
                {
                    key: 'added',
                    label: 'Дата',
                    sortable: true
                },
                {
                    key: 'quest_name',
                    label: 'Питання',
                    sortable: true
                },
                {
                    key : 'title',
                    label: 'Тема',
                    sortable: false
                },
                
                {
                    key: 'tov_title',
                    label: 'Організація',
                    sortable: true
                },
                
                {
                    key: 'init_name',
                    label: 'Ініціатор',
                    sortable: true
                },
                
                {
                    key: 'rec_name',
                    label: 'Затвердження',
                    sortable: true
                },
                {
                    key: 'isp_name',
                    label: 'Виконавець',
                    sortable: true
                },
            
            ],
            files: [],
        }
    },
    
    created() {
        this.getFiles();
    },
    
    computed: {},
    
    methods: {
        show_loading(flag) {
            this.$store.dispatch('memorandum_work_tabs/SET_MEM_LOAD_TAB', {
                type: this.$options.name,
                active: flag
            });
        },
        
        async getFiles() {
            
            this.show_loading(true);
            await api.get('/memorandums/ '+ this.doc_id +'/linked',).then(({data}) => {
                if (data.status === "operation_success") {
                    this.files = data.data;
                    
                    this.$store.dispatch('memorandum_work_tabs/SET_MEM_TAB_COUNT', {
                        type: this.$options.name,
                        count:   this.files.length,
                    });
                    
                    this.show_loading(false);
                }
            }).catch(err => {
                this.show_loading(false);
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
            
        },
        
    },
}
</script>

<style scoped>
.linked_block i {
    cursor: pointer;
}


.linked_block a {
    color:#0056b3;
}

.linked_block a:hover {
    color:black;
}

</style>
